var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'pang-font': !_vm.isDashboard},attrs:{"id":"app"}},[_c('router-view'),(_vm.showFooter)?_c('bottom-com'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }